
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import DashboardLayout from "../components/DashboardLayout";
import BlogSection from "../components/BlogSection";
import { BlogPost } from "../components/BlogCard";
import PageCallToAction from "../components/PageCallToAction";
import { Input } from "@/components/ui/input";
import { getBlogPosts, getFeaturedBlogPosts } from "../content";

const Blog = () => {
  const [searchTerm, setSearchTerm] = useState("");
  // Synchronously get posts (since now loaded at build time)
  const [allPosts] = useState<BlogPost[]>(getBlogPosts());
  const [featuredPosts] = useState<BlogPost[]>(getFeaturedBlogPosts());

  // No loading spinner needed: posts available synchronously

  const filteredPosts = allPosts.filter(
    (post) =>
      post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.excerpt?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredFeaturedPosts = searchTerm
    ? featuredPosts.filter(
        (post) =>
          post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          post.excerpt?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          post.category.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : featuredPosts;

  const sortedAllPosts = [...filteredPosts].sort((a, b) => {
    return new Date(b.date).getTime() - new Date(a.date).getTime();
  });

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  return (
    <DashboardLayout>
      <Helmet>
        <title>Blog | OpenPipe</title>
        <meta
          name="description"
          content="Explore our latest research and updates on building SOTA agents."
        />
      </Helmet>
      <div className="max-w-7xl mx-auto">
        {/* Site-wide blog search bar */}
        <div className="mb-8 flex justify-center">
          <Input
            type="text"
            placeholder="Search articles..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="w-full max-w-lg px-4 py-2 border border-border rounded-md"
          />
        </div>

        {/* Featured Posts */}
        {filteredFeaturedPosts.length > 0 && (
          <BlogSection
            className="pt-1 pb-8"
            title="Featured Posts"
            description="Explore our latest research and updates on building SOTA agents."
            posts={filteredFeaturedPosts}
          />
        )}

        {/* All Articles */}
        {sortedAllPosts.length > 0 && (
          <BlogSection
            title="All Articles"
            description="Stay updated with our most recent research and insights."
            posts={sortedAllPosts}
          />
        )}

        <PageCallToAction />
      </div>
    </DashboardLayout>
  );
};

export default Blog;
